module.exports = __webpack_public_path__ + "assets/icons/ic_admin_24px.svg";